<template>
  <div>
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @resetBtn="resetBtn"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:Status>
        <el-select
          multiple
          v-model="filters.Status"
          filterable
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in statuslist"
            :label="item.text"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:ShippingStatus>
        <el-select
          multiple
          v-model="filters.ShippingStatus"
          filterable
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in ShippingStatuslist"
            :label="item.text"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:DesWarehouseID>
        <el-select
          multiple
          v-model="filters.DesWarehouseID"
          filterable
          placeholder="请选择发货仓"
          collapse-tags
        >
          <el-option
            v-for="item in warehouselist"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:TransportType>
        <el-select
          multiple
          v-model="filters.TransportType"
          filterable
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in transportList"
            :label="item.text"
            :value="item.text"
            :key="item.text"
          ></el-option>
        </el-select>
      </template>
      <!-- @click.native="PreviewsPDF(scope.row.skuCode,scope.row.uploadFileInfoId)" -->
      <template slot-scope="scope" slot="uploadFileInfoId">
        <el-link
          :underline="false"
          type="primary"
          @click.native="DownloadProductSKUAttachBtn(scope.row.taskFileList)"
          >{{ scope.row.taskFileList.length > 0 ? "下载" : "" }}
        </el-link>
      </template>
    </TwTable>

    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{ businessType: 12, businessCode: currentRow.shippingNo }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>

    <el-dialog title="条码上传" :visible.sync="showUploadBarCodeDielog">
      <div>
        <el-upload
          class="upload-demo upload-pdf"
          drag
          :action="`${BaseApiUrl}/Img/InsertFtpImage`"
          :limit="1"
          accept=".pdf"
          name="files"
          :on-success="handleFileSuccess"
          :on-error="handleFileError"
          :before-upload="beforeUpload"
          :auto-upload="false"
          ref="uploadPDF"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传PDF文件。</div>
        </el-upload>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitUploadPDF"
          :loading="fileLoading"
          >{{ fileLoading ? "上传中" : "上传"
          }}<i v-if="!fileLoading" class="el-icon-upload el-icon--right"></i
        ></el-button>
        <el-button @click="showUploadBarCodeDielog = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="请选择条码文件类型"
      :visible.sync="dialogVisible"
      width="400px"
    >
      <el-radio v-model="barCodeRadio" :label="1">常规</el-radio>
      <el-radio v-model="barCodeRadio" :label="4">欧英代</el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="printBarCode()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import util from "../../../util/date";
import {
  GetShippingPlanList,
  ShippingPlanExport,
  skipWaitPickUrl,
  SynchroPackDataToBaiYi,
  SynchroPutCarDataToBaiYi,
  PlanUploadBarcode,
  CheckPlanBarcodeIsExist,
  BatchDownloadBarCodeFile,
  PreviewsBarCodePDF,
  ShipplanOccTask,
  ShipplanOccTaskBack,
  editStockingPlanRelationByStatus,
} from "@/api/outbound/shippingPlan.js";
import { printLog, downPdfFile } from "@/api/outbound/readyforTask.js";
import {
  GetShippingPlanStatusList,
  GetPlanRelationStatusList,
  GetTransportTypeList,
} from "@/api/common/common.js";
import { DownloadProductSKUAttach } from "@/api/ProductSku.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import Toolbar from "../../components/Toolbar";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import OperateDialog from "../../components/TwTable/components/operateDialog";
import LogDialog from "../../components/TwTable/components/logDialog";
import axios from "axios";
import { thereAre } from "util/util";
import { BaseApiUrl } from "@/api/axios_config";
export default {
  components: { Toolbar, TwTable, OperateDialog, LogDialog },
  mixins: [TwTable_mixins],
  data() {
    return {
      tableConfig: {
        showResetButton: true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          width: "100",
          align: "center",
          options: [
            {
              name: "日志",
              size: "small",
              type: "text",
              event: "getbusinessLoglist", // 操作的事件名
            },
          ],
        },

        column: [
          // 表格列配置
          {
            prop: "shippingNo",
            label: "出库计划",
            align: "center",
            sortable: true,
            minWidth: "160",

            // formatter: function (val, row) {
            //   return row.twDeliveryNo + "<br/>" + row.relationNumber;
            // },
          },

          {
            prop: "skuCode",
            label: "SKU",
            align: "center",
            sortable: true,
            minWidth: "200",
          },
          {
            prop: "reference",
            label: "参考信息",
            align: "left",
            sortable: true,
            minWidth: "220",
            formatter: function (val, row) {
              var html =
                "发货计划编码：" +
                row.sourceNo +
                "<br/>" +
                "货柜号:" +
                row.containerNo +
                "<br/>" +
                "备货单号:" +
                row.stockingNo +
                "<br/>" +
                "调拨单号:" +
                row.stockTransferNo;

              return html;
            },
          },

          {
            prop: "transportType",
            label: "运输方式",
            align: "center",
            minWidth: "120",
          },
          {
            prop: "sendWarehouseName",
            label: "仓库信息",
            align: "left",
            sortable: false,
            minWidth: "260",
            formatter: function (val, row) {
              var html =
                "发货仓:" +
                row.sendWarehouseName +
                "<br/>" +
                "目的仓:" +
                row.destinationWarehouseName +
                "<br/>" +
                "调入仓:" +
                (row.traInWarehouseName || "");

              return html;
            },
          },

          {
            prop: "uploadFileInfoId",
            label: "条码文件",
            align: "center",
            sortable: true,
            minWidth: "100",
            slot: true,
          },
          {
            prop: "shippingStatusDesc",
            label: "状态信息",
            align: "left",
            sortable: true,
            minWidth: "160",
            formatter: function (val, row) {
              var html =
                "计划:" +
                row.shippingStatusDesc +
                "<br/>" +
                "备货:" +
                row.statusDesc;
              return html;
            },
          },

          {
            prop: "quantity",
            label: "数量",
            align: "left",
            sortable: true,
            minWidth: "150",
            formatter: function (val, row) {
              var html =
                "计划数量:" +
                row.planQty +
                "<br/>" +
                "备货数量:" +
                row.quantity +
                "<br/>" +
                "占用数量:" +
                row.occupyQty;
              return html;
            },
          },

          {
            prop: "remark",
            label: "备注",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
        ],
      },
      visibledialogDetail: false,
      InOutDetailTableData: [],
      batchesInventoryTableData: [],
      logListLoading: false,
      logListLoadingInOut: false,
      showLogInOut: false,
      showDialogInout: false,
      activeName: "first",
      batchesInventoryListLoading: false,
      receiveBoxData: {},
      boxtabledata: [],
      signFortabledata: [],
      receivetableData: [],
      putOntableData: [],
      DetailForm: {},
      tabpara: {},

      ShippingStatuslist: [],
      statuslist: [],
      transportList: [],
      warehouselist: [],
      searchData: {
        //搜索列配置
        search: [
          {
            type: "input",
            key: "ShippingNo",
            label: "出库计划",
            placeholder: "请输入出库计划",
            clearable: true,
          },
          {
            type: "input",
            key: "SourceNo",
            label: "计划编码",
            placeholder: "请输入计划编码",
            clearable: true,
          },
          {
            type: "input",
            key: "ContainerNo",
            label: "货柜号",
            placeholder: "请输入货柜号",
            clearable: true,
          },
          {
            type: "input",
            key: "SKUCode",
            label: "SKU",
            placeholder: "多个SKU用逗号分开查询",
            clearable: true,
          },

          
        ],
        ///高级搜索配置
        moreSearch: [
          {
            type: "select",
            key: "Status",
            prop: "Status",
            label: "备货状态",
            multiple: true,
            slot: true,
            placeholder: "请选择状态",
            option: this.statuslist,
          },
          {
            type: "select",
            key: "DesWarehouseID",
            prop: "DesWarehouseID",
            label: "发货仓",
            multiple: true,
            slot: true,
            placeholder: "请选择发货仓",
            option: this.warehouselist,
          },
          {
            type: "select",
            key: "TransportType",
            prop: "TransportType",
            label: "运输方式",
            multiple: true,
            slot: true,
            placeholder: "请选择运输方式",
          },
          {
            type: "input",
            key: "StockTransferNo",
            label: "调拨单",
            placeholder: "请输入调拨单号",
            clearable: true,
          },
          {
            type: "input",
            key: "InStockSKUCode",
            label: "调入仓SKU",
            placeholder: "请输入调入仓SKU",
            clearable: true,
          },

          {
            type: "select",
            key: "ShippingStatus",
            prop: "ShippingStatus",
            label: "计划状态",
            multiple: true,
            slot: true,
            placeholder: "请选择状态",
            option: this.ShippingStatuslist,
          },
          {
            type: "input",
            key: "StockingNo",
            label: "备货单号",
            placeholder: "请输入备货单号",
            clearable: true,
          },
        ],
      },
      buttonList: [],

      //-------------
      filters: {},
      organizations: [],
      warehouses: [],
      logPageConfiginOut: {
        // 日志分页配置
        total: 0,
        pageIndex: 0,
        pageSize: 20,
        pageSizes: [10, 20, 50, 100],
      },
      showUploadBarCodeDielog: false,
      BaseApiUrl: BaseApiUrl,
      fileLoading: false,
      curUploadFilePDFUrl: "",
      barCodeRadio: 1,
      dialogVisible: false,
    };
  },
  methods: {
    resetBtn() {
      this.filters = {};
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },
    //查询列表
    initTable() {
      const {
        StockingNo,
        ContainerNo,
        Status,
        DesWarehouseID,
        TransportType,
        StockTransferNo,
        SKUCode,
        InStockSKUCode,
        ShippingNo,
        ShippingStatus,
        SourceNo,
      } = this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        StockingNo: StockingNo,
        ContainerNo: ContainerNo,
        StockTransferNo: StockTransferNo,
        Status: thereAre(Status),
        ShippingStatus: thereAre(ShippingStatus),
        DesWarehouseIDs: thereAre(DesWarehouseID),
        TransportTypes: thereAre(TransportType),
        SKUCode: SKUCode,
        InStockSKUCode: InStockSKUCode,
        ShippingNo: ShippingNo,
        SourceNo: SourceNo,
      };

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      GetShippingPlanList(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);

        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    Dateformatter(row, column) {
      return util.formatDate.format(
        new Date(row.createTime),
        "yyyy-MM-dd hh:mm:ss"
      );
    },
    //回滚重新打包
    rollBackPackaging() {
      let row = this.selectRows.rows;
      let checkData = [];
      if (row.length <= 0) {
        this.$message({
          message: "请选择数据",
          type: "error",
        });
        return;
      }
      var stockingTaskID = row[0].stockingTaskID;
      for (var i = 0; i < row.length; i++) {
        if (row[i].stockingTaskID !== stockingTaskID) {
          this.$message({
            message: "请选择同一备货任务计划",
            type: "error",
          });
          return;
        }
        if (row[i].stockingNo === "BH-0001") {
          this.$message({
            message: "暂不支持回滚系统备货任务计划",
            type: "error",
          });
          return;
        }

        if (row[i].stockingPlanRelationID === 0) {
          this.$message({
            message: "SKU:" + row[i].skuCode + "未关联备货任务",
            type: "error",
          });
          return;
        }
        if (row[i].status < 40 || row[i].status > 70) {
          this.$message({
            message: "已包装未装车的状态才允许操作，请确认",
            type: "error",
          });
          return;
        }
        checkData.push(row[i].stockingPlanRelationID);
      }

      this.$confirm(
        "此操作将回滚SKU：" +
          row.map((item) => item.skuCode).join(",") +
          "重新打包（如SKU中存在混箱将同步回滚混箱计划），是否确定？",
        "提示",
        {}
      ).then(() => {
        editStockingPlanRelationByStatus(checkData).then((res) => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.initTable();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },

    skipWaitPick() {
      let row = this.selectRows.rows;

      if (row.length <= 0) {
        this.$message({
          message: "请选择一行数据",
          type: "error",
        });
        return;
      }
      if (row.length > 1) {
        this.$message({
          message: "请选择一行数据",
          type: "error",
        });
        return;
      }

      if (row[0].status != 10 && row[0].status != 15) {
        this.$message({
          message: "请选择 状态为：待拣货、拣货中的数据",
          type: "error",
        });
        return;
      }
      console.log(JSON.stringify(row[0].shippingNo));

      window.location.href =
        skipWaitPickUrl +
        "?ShippingNo=" +
        row[0].shippingNo +
        "&SKUCode=" +
        row[0].skuCode;
      //  window.location.href = skipWaitPickUrl?ShippingNo=&SKUCode=1
      // " +id+"&name="+ escape(name);
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;

      let checkIds = "";
      row.forEach((item) => {
        checkIds += item.shippingPlanID + ",";
      });
      if (checkIds != null || checkIds != "") {
        checkIds = checkIds.substring(0, checkIds.lastIndexOf(","));
      }

      const {
        StockingNo,
        ContainerNo,
        Status,
        DesWarehouseID,
        TransportType,
        StockTransferNo,
        SKUCode,
        InStockSKUCode,
        ShippingStatus,
        ShippingNo,
        SourceNo,
      } = this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        StockingNo: StockingNo,
        ContainerNo: ContainerNo,
        StockTransferNo: StockTransferNo,
        Status: thereAre(Status),
        ShippingStatus: thereAre(ShippingStatus),
        DesWarehouseIDs: thereAre(DesWarehouseID),
        TransportTypes: thereAre(TransportType),
        SKUCode: SKUCode,
        InStockSKUCode: InStockSKUCode,
        ShippingNo: ShippingNo,
        CheckIds: checkIds,
        SourceNo: SourceNo,
      };

      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: ShippingPlanExport,
        method: "post",
        data: para,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
          loading.close();
        });
    },

    syncPackData() {
      let row = this.selectRows.rows;

      if (row.length <= 0) {
        this.$message({
          message: "请选择一行数据",
          type: "error",
        });
        return;
      }
      if (row.length > 1) {
        this.$message({
          message: "请选择一行数据",
          type: "error",
        });
        return;
      }

      if (row[0].status != 50) {
        this.$message({
          message: "请选择 状态为：待同步的数据",
          type: "error",
        });
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "同步中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      SynchroPackDataToBaiYi({ StockingTaskID: row[0].stockingTaskID }).then(
        (res) => {
          loading.close();
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });

            this.initTable();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      );
    },

    //弹出打印条码
    printChoice() {
      let row = this.selectRows.rows;

      if (row == null || row.length != 1) {
        this.$message({
          message: "请选择一行数据",
          type: "error",
        });
        return;
      }
      console.log(row[0].taskFileList);
      if (row[0].taskFileList == null || row[0].taskFileList.length === 0) {
        this.$message({
          message: "计划还未上传条码文件",
          type: "error",
        });
        return;
      }

      this.dialogVisible = true;
    },
    //打印条码
    printBarCode() {
      let row = this.selectRows.rows;
      if (row === null || row.length != 1) {
        this.$message({
          message: "请选择一行数据",
          type: "error",
        });
        return;
      }
      console.log(
        this.barCodeRadio === 1 ? "常规" : "欧英代",
        this.barCodeRadio
      );
      let taskFile = row[0].taskFileList.filter((m) => {
        return m.stockingTaskFileType === this.barCodeRadio;
      });
      if (taskFile === null || taskFile.length === 0) {
        this.$message({
          message:
            "佰易未推送" +
            (this.barCodeRadio === 1 ? "常规" : "欧英代") +
            "文件",
          type: "error",
        });
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      printLog({
        sourceID: row[0].shippingPlanID,
        type: "PCShippingPlan",
      }).then((res) => {
        if (res.data.success) {
          window.open(taskFile[0].fileUrl);
          this.dialogVisible = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        loading.close();
      });
    },

    //下载查看计划条码文件
    DownloadProductSKUAttachBtn(imgurls) {
      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      imgurls.forEach((file) => {
        if (file.uploadType === 1) {
          DownloadProductSKUAttach(file.fileUrl, file.fileUrl);
        }
        if (file.uploadType === 2) {
          const data = {
            fielUrl: file.fileUrl,
          };
          axios
            .get(downPdfFile, {
              params: data,
            })
            .then((res) => {
              console.log(res);
              if (res.data.success) {
                var data = res.data;
                var arr = data.msg.split(",");
                var mime = arr[0].match(/:(.*?);/)[1];
                var bstr = atob(arr[1]);
                var n = bstr.length;
                var u8arr = new Uint8Array(n);
                while (n--) {
                  u8arr[n] = bstr.charCodeAt(n);
                }
                var blob = new Blob([u8arr], { type: mime });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                let fileName =
                  file.fileName === ""
                    ? ""
                    : file.fileName.indexOf(".pdf") > -1
                    ? file.fileName
                    : file.fileName + ".pdf";
                a.download = decodeURIComponent(fileName);
                a.click();
                window.URL.revokeObjectURL(url);
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.error(err);
            });
          // const a = document.createElement("a");
          // //   let url = baseUrl + binding.value // 若是不完整的url则需要拼接baseURL
          //  fetch(url)
          //  //this.$http
          //  //.jsonp(url)
          //   .then((res) => res.blob())
          //   .then((blob) => {
          //      console.log(blob);
          //     // 将链接地址字符内容转变成blob地址
          //     a.href = URL.createObjectURL(blob);
          //     console.log(a.href);
          //     a.download =file.fileName===""?"":file.fileName; // 下载文件的名字
          //     // a.download = url.split('/')[url.split('/').length -1] //  // 下载文件的名字
          //     document.body.appendChild(a);
          //     a.click();
          //   });
        }
      });
      loading.close();
    },

    shipplanOcc() {
      let row = this.selectRows.rows;
      let checkData = [];

      if (row.length <= 0) {
        this.$message({
          message: "请选择数据",
          type: "error",
        });
        return;
      }
      for (var i = 0; i < row.length; i++) {
        if (![0, 10, 20].includes(row[i].shippingStatus)) {
          this.$message({
            message: "已备货完成的计划不允许再配货",
            type: "error",
          });
          return;
        }
        checkData.push(row[i].shippingNo);
      }

      const loading = this.$loading({
        lock: true,
        text: "配货中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      console.log(checkData);
      ShipplanOccTask(checkData).then((res) => {
        loading.close();
        if (res.data.status === 200) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });

          this.initTable();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },

    cancelShipplanOcc() {
      let row = this.selectRows.rows;
      let checkData = [];

      if (row.length <= 0) {
        this.$message({
          message: "请选择数据",
          type: "error",
        });
        return;
      }
      for (var i = 0; i < row.length; i++) {
        if (row[i].shippingStatus != 10) {
          this.$message({
            message: "待备货计划才允许取消配货",
            type: "error",
          });
          return;
        }
        checkData.push(row[i].shippingNo);
      }

      const loading = this.$loading({
        lock: true,
        text: "取消配货中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      ShipplanOccTaskBack(checkData).then((res) => {
        loading.close();
        if (res.data.status === 200) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });

          this.initTable();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    initDropList() {
      GetShippingPlanStatusList({}).then((res) => {
        this.ShippingStatuslist = res.data.response;
      });

      GetPlanRelationStatusList({}).then((res) => {
        this.statuslist = res.data.response;
      });

      GetTransportTypeList({}).then((res) => {
        this.transportList = res.data.response;
      });
    },

    // 手动上传文件pdf
    submitUploadPDF() {
      this.$refs.uploadPDF.submit();
      if (!this.curUploadFilePDFUrl.length) {
      } else {
        this.CheckPlanBarcodeIsExist();
      }
    },

    uploadBarCode() {
      if (this.selectRows.rows.length != 1) {
        this.$message({
          message: "请选择一行数据",
          type: "error",
        });
        return;
      }
      if (this.selectRows.rows[0].stockingTaskID <= 0) {
        this.$message({
          message: "货柜信息不存在，不能上传条码。",
          type: "error",
        });
        return;
      }

      this.showUploadBarCodeDielog = true;
      this.$nextTick(() => {
        this.$refs.uploadPDF.clearFiles();
        this.curUploadFilePDFUrl = "";
      });
    },

    // 下载条码
    downloadBarCode() {
      if (this.selectRows.rows.length < 1) {
        this.$message({
          message: "请至少选择一行数据",
          type: "error",
        });
        return;
      }

      const data = [];
      this.selectRows.rows.forEach((item, i) => {
        const {
          stockingTaskID,
          stockingPlanRelationID,
          skuCode,
          shippingNo,
          sourceNo,
        } = item;
        let obj = {
          stockingTaskID,
          stockingPlanRelationID,
          skuCode,
          shippingNo,
          sourceNo,
        };

        data.push(obj);
      });

      BatchDownloadBarCodeFile(data).then((res) => {
        if (res.data.status === 200) {
          const a = document.createElement("a");
          const url = res.data.response.fileData;

          fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
              a.href = URL.createObjectURL(blob);
              a.download = res.data.response.fileName;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },

    // pdf上传成功事件
    handleFileSuccess(res, file, fileList) {
      this.curUploadFilePDFUrl = res.response[0].urlPath;
      this.CheckPlanBarcodeIsExist();
    },

    // pdf上传失败事件
    handleFileError(err, file, fileList) {
      this.$message({
        message: "文件上传失败，请选择小的文件",
        type: "error",
      });
    },

    beforeUpload(file) {
      let fileObj = {
        name: file.name,
        size: file.size,
        status: "开始上传",
        process: 0,
        id: file.uid,
      };
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          message: "上传文件不能大于10M，请选择小的文件",
          type: "error",
        });
        return false; //必须返回false
      }
    },

    // 上传条码
    uploadFile() {
      this.fileLoading = true;

      const {
        stockingTaskID,
        stockingPlanRelationID,
        shippingPlanDetailID,
        shippingNo,
        skuCode,
      } = this.selectRows.rows[0];
      const data = {
        stockingTaskID,
        stockingPlanRelationID,
        shippingPlanDetailID,
        pdfUrl: this.curUploadFilePDFUrl,
        shippingNo,
        skuCode,
      };

      PlanUploadBarcode(data).then((res) => {
        this.fileLoading = false;
        this.showUploadBarCodeDielog = false;
        if (res.data.status === 200 && res.data.success) {
          this.$message({
            type: "success",
            message: "上传成功!",
          });

          this.initTable();
          this.$nextTick(() => {
            this.$refs.uploadPDF.clearFiles();
          });
          this.showUploadBarCodeDielog = false;
        } else {
          this.$message({
            type: "warning",
            message: res.data.msg,
          });
        }
      });
    },

    // 校验条码是否存在
    CheckPlanBarcodeIsExist() {
      const {
        stockingTaskID,
        stockingPlanRelationID,
        shippingPlanDetailID,
        shippingNo,
        skuCode,
      } = this.selectRows.rows[0];
      const data = {
        stockingTaskID,
        stockingPlanRelationID,
        shippingPlanDetailID,
        pdfUrl: this.curUploadFilePDFUrl,
        shippingNo,
        skuCode,
      };

      CheckPlanBarcodeIsExist(data).then((res) => {
        if (!res.data.success) {
          this.$confirm("该数据已存在条码文件, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.uploadFile();
            })
            .catch(() => {});
        } else {
          this.uploadFile();
        }
      });
    },

    PreviewsPDF(skuCode, id) {
      const loading = this.$loading({
        lock: true,
        text: "文件加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      PreviewsBarCodePDF({ uploadFileInfoId: id, skuCode }).then((res) => {
        loading.close();
        if (res.data.status === 200 && res.data.success) {
          let { fileName, fileData } = res.data.response;

          // 下载pdf
          function convertBase64ToBlob(base64, fileType, slice) {
            return new Blob(
              atob(base64)
                .match(
                  new RegExp(`([\\s\\S]{${slice}})|([\\s\\S]{1,${slice}})`, "g")
                )
                .map(function (item) {
                  return new Uint8Array(
                    item.split("").map(function (s, i) {
                      return item.charCodeAt(i);
                    })
                  );
                }),
              { type: fileType }
            );
          }

          const blob = convertBase64ToBlob(fileData, "application/pdf", 1024);
          if (navigator.msSaveBlob) {
            return navigator.msSaveBlob(blob, fileName);
          }
          const urlFromBlob = window.URL.createObjectURL(blob);
          window.open(urlFromBlob);

          // const a = document.createElement('a');
          // a.style.display = 'none';
          // a.href = urlFromBlob;
          // // a.download = fileName;
          // document.body.appendChild(a);
          // a.setAttribute('target','_blank')
          // a.click();
          // window.URL.revokeObjectURL(urlFromBlob);
          // document.body.removeChild(a)
        } else {
          this.$message({
            type: "warning",
            message: res.data.msg,
          });
        }
      });
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);

    let user = JSON.parse(window.localStorage.user);

    this.warehouselist = user.warehouseList;

    this.initDropList();
  },
};
</script>

<style scoped>
.upload-pdf {
  text-align: center;
}
</style>

